import React, { useState } from "react";
import { FA_ICONS } from "../assets/fa-icons/faIcons";

interface IconPickerProps {
    value: string;
    onChange: (newIcon: string) => void;
}

const IconPicker: React.FC<IconPickerProps> = ({ value, onChange }) => {
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [showIcons, setShowIcons] = useState<boolean>(false);

    const filteredIcons = FA_ICONS.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleIconClick = (iconClass: string) => {
        onChange(iconClass);
        setShowIcons(false);
    }


    return (
        <div className="position-relative d-inline-block">
            {/* Muestra el icono seleccionado y un boton para abrir/cerrar el grid */}
            <div
                className="border p-2 rounded-d-flex align-items-center"
                style={{ cursor: 'pointer', minWidth: '200px' }}
                onClick={() => setShowIcons(!showIcons)}
            >
                <i className={`${value} me-2`} />
                <span>{value}</span>
            </div>
            {showIcons && (
                <div
                    className="bg-white border rounded p-2 mt-1 position-absolute"
                    style={{
                        zIndex: 999,
                        width: '280px',
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }}
                >
                    {/* Input de Búsqueda */}
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar ícono..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    {/* Grid de íconos */}
                    <div className="row row-cols-6 g2">
                        {filteredIcons.map((icon) => (
                            <div className="col" key={icon.iconClass}>
                                <div
                                    className={`border rounded d-flex align-items-center justify-content-center ${icon.iconClass === value ? 'border-primary' : 'border-secondary'}`}
                                    style={{ height: '40px', cursor: 'pointer' }}
                                    onClick={()=> handleIconClick(icon.iconClass)}
                                    title={icon.label}
                                >
                                    <i className={icon.iconClass}/>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default IconPicker;
